export default {
    LOAD_CONTRACT(state, contract) {
        state.items = contract;
    }
}